<template>
  <PageMain
    ref="main"
    :loading="loading"
    :tableData="tableData"
    :tablePage="page"
    @reload="getData()"
  >
    <pagination
      slot="pager"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      @change="handlePaginationChange"
    />
  </PageMain>
</template>
<script>
import PageMain from './main'
const initPage = { curPage: 1, pageSize: 20, pageTotal: 0 }
export default {
  components: { PageMain },
  props: {
    custCode: { type: String, default: '' },
    rptYear: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page: { ...initPage },
    }
  },
  watch: {
    rptYear() {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.page = { ...initPage }
      this.getData()
    },
    async getData() {
      if (!this.custCode) return
      this.loading = true
      const res = await this.$api
        .customerReportListGoodsApi({
          custCode: this.custCode,
          rptYear: this.rptYear,
          ...this.page,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
      this.page.pageTotal = res.body.count
      this.page.pageSize = res.body.pageSize
      this.page.curPage = res.body.curPage
    },
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.getData()
    },
  },
}
</script>
